<div>
  <i
    routerLink="/myaccount/manage-commissions"
    class="fa-solid fa-circle-arrow-left back-icon float-start"
    title="Back to Manage Commissions Page">
  </i>
</div>
<div class="page-header-bar">
  <section class="account-signatures">
    <h2>Account Signatures</h2>
    <button class="btn-primary action-btn filter-btn"
      data-backdrop="static"
      data-keyboard="false"
      (click)="openAddAccountSignatureModal()"
      >
      + Add Signature
    </button>
  </section>
  <div>View and manage your active Account Signatures</div>
</div>
<div>
  <div class="signatures">
    @for (accountSignature of signatures(); track accountSignature; let i = $index) {
      <div>
        <mat-card>
          <mat-card-header>
            <section class="accountSignature-image-container">
                <img
                  alt="Account Signature '{{ accountSignature.name }}'"
                  class="accountSignature-image"
                  [src]="
                    getSanitizedImage(
                      accountSignature.signatureImageBase64,
                      accountSignature.imageType
                    )
                  "
                />
              </section>
            </mat-card-header>
            <mat-card-content>
              <div class="headline">
                <span class="bold">Signature Name:</span> {{accountSignature.name}}
              </div>
            </mat-card-content>
            <mat-card-footer>
              <mat-card-actions align="end">
                @if (!accountSignature.commissionGuid) {
                  <button
                    (click)="deleteConfirmationDialog(accountSignature)"
                    class="btn-secondary">
                    Delete
                  </button>
                }
                <button (click)="openEditAccountSignatureModal(accountSignature)"
                  class="btn-primary hide">
                  Edit
                </button>
              </mat-card-actions>
            </mat-card-footer>
          </mat-card>
        </div>
      }
    </div>
  </div>
